const dataMixin = {
  data() {
    return {
      selectedValue: this.transformValue(this.$props.value),
      internalOptions: this.getInternalOptions(),
      internalUrl: this.$props.url,
      showResults: this.options.length > 0 || this.trending.length > 0,
      showError: false,
      fullscreen: this.$props.desktopFullscreen,
      fullscreenOpen: false,
      mobile: false,
      mobileListHeightAdjusted: false,
      searchDisabled: false,
      selectProps: {
        closeOnSelect: this.$props.closeOnSelect,
        clearOnSelect: this.$props.clearOnSelect,
        preserveSearch: this.$props.preserveSearch,
        allowEmpty: false,
        showLabels: false,
        showPointer: true,
        showNoOptions: false,
        openDirection: "below"
      },
      multiselectProps: {
        allowEmpty: true,
        showLabels: false,
        showPointer: true,
        showNoOptions: false,
        openDirection: "below",
        closeOnSelect: false
      }
    };
  },
  methods: {
    getInternalOptions() {
      if (this.options.length > 0) {
        return this.options;
      } else if (this.trending.length > 0) {
        return this.trending;
      } else {
        return [];
      }
    }
  }
};

export default dataMixin;
